export default function ArrowRightIcon({
  className = '',
  width = 27.12,
  height = 9.755,
  fill = '#FFC628',
  ...props
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 28 10"
      fill="none"
      className={className}
      {...props}
    >
      <path
        d="M0.480024 4.37094H25.4702L21.9186 0.819375C21.7311 0.632031 21.7311 0.32797 21.9186 0.140626C22.1061 -0.0468752 22.4099 -0.0468752 22.5974 0.140626L26.9161 4.45934C27.0391 4.54625 27.1199 4.68887 27.1199 4.85094C27.1199 4.8534 27.1192 4.85568 27.1191 4.85814C27.1192 4.8634 27.1177 4.86836 27.1176 4.87361C27.1154 4.92055 27.1062 4.96533 27.0915 5.00779C27.0828 5.03474 27.0704 5.05906 27.0568 5.08445C27.0447 5.10601 27.0313 5.12642 27.0161 5.14578C27.0026 5.16376 26.9956 5.18488 26.9792 5.20125L22.5657 9.61484C22.4719 9.70859 22.3491 9.75546 22.2263 9.75546C22.1035 9.75546 21.9807 9.70859 21.8869 9.61484C21.6994 9.42734 21.6994 9.12359 21.8869 8.93609L25.4921 5.33094H0.480024C0.215027 5.33094 2.47955e-05 5.11609 2.47955e-05 4.85094C2.47955e-05 4.58578 0.215027 4.37094 0.480024 4.37094Z"
        fill={fill}
      />
    </svg>
  )
}
